// Forex Rate Conversion Types
export interface ForexConversionRequest {
  currentCurrency: string;
  targetCurrency: string;
  amount: number;
}

export interface ForexConversionResponse {
  success: boolean;
  code: number;
  convertedAmount: number;
  convertedCurrency: string;
  currencyId: number;
  message: string;
}

export interface ForexRateConversionProps {
  isOpen: boolean;
  onClose: () => void;
  currentCurrency: string;
  currentCurrencyId: number;
  amount: number;
  onConversionComplete: (convertedAmount: number, convertedCurrency: string, currencyId: number) => void;
  previousConversion?: {
    currency: string;
    amount: number;
    currencyId: number;
  } | null;
  isInbound?: boolean;
}

export interface ConvertedPlanInfo {
  originalCurrency: string;
  originalAmount: number;
  convertedCurrency: string;
  convertedAmount: number;
  currencyId: number;
  conversionTimestamp: string;
}

// Enhanced interface for storing converted currency data in tempData
export interface ConvertedCurrencyData {
  // Original plan data (preserved for reference)
  originalCurrencyCode: string;
  originalRateAmount: number;
  originalCurrencyId?: number;
  
  // Converted currency data (used for calculations and display)
  convertedCurrencyCode: string;
  convertedRateAmount: number;
  convertedCurrencyId: number;
  
  // Conversion metadata
  isForexConverted: true;
  conversionTimestamp: string;
  conversionRate?: number;
}

// Helper type for tempData with forex conversion support
export interface TempDataWithForexConversion {
  // Standard tempData fields
  productName?: string;
  typeName?: string;
  rateAmount?: number;
  currencyCode?: string;
  currencyId?: number;
  
  // Forex conversion fields (added when conversion occurs)
  originalCurrencyCode?: string;
  originalRateAmount?: number;
  originalCurrencyId?: number;
  isForexConverted?: boolean;
  conversionTimestamp?: string;
  conversionRate?: number;
  
  // Other existing tempData fields...
  [key: string]: unknown;
}

export interface CurrencyOption {
  code: string;
  name: string;
  symbol: string;
}

export const SUPPORTED_CURRENCIES: CurrencyOption[] = [
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'PHP', name: 'Philippine Peso', symbol: '₱' }
];